import { LocalStorageLoader } from "@alme/storage-ts/LocalStorageLoader";
import SFDDLObject from "../data/_SFDDL/eservice.json";
import PSCCNavResponseObject from "../data/PSCCNavResponse.json";
const savedTestPageState = new LocalStorageLoader('almeUiTestPageState');
export function updateTestPageState(state) {
    try {
        savedTestPageState.UpdateStorage(state);
    }
    catch (ex) {
        console.error(ex);
    }
}
export function getTestPageState() {
    let testPageState = null;
    try {
        testPageState = savedTestPageState.GetStorage();
    }
    catch (ex) {
        console.error(ex);
    }
    return testPageState;
}
export const defaultTestPageState = {
    loginParams: {
        clientSessionId: '1234',
        userMetadata: {
            accountNumber: '1234',
            cifId: '0000',
            primaryName: 'Sydney AwesomeIva',
            zipCode: '99216',
            accountType: 'Generic',
        },
    },
    launchSettings: {
        launchPointName: 'Global',
        launchParameter: 'Main',
    },
    SFDDL: JSON.stringify(SFDDLObject),
    PSCCNavResponse: JSON.stringify(PSCCNavResponseObject),
};
